const APP_BASE_URL = 'https://app.talented.education';
const DEV_BASE_URL = 'https://dev.talented.education';

const getTalentedAppBaseUrl = () => {
	const appEnv = (process.env.ENV_APP ?? '').toLowerCase();
	return ['dev', 'development', 'stage', 'staging'].includes(appEnv) ? DEV_BASE_URL : APP_BASE_URL;
};

export default getTalentedAppBaseUrl;
